import Card from '../../../../components/Card'
import React from 'react'
import Text from '../../../../components/Text'
import { useTranslation } from 'react-i18next'
import cx from 'classnames'
import styles from './UploadTemplates.module.css'
import DropInput from '../../../../components/DropInput'
import { useIndividualizationContext } from '../../../../contexts/individualizationContext'

const NewTemplateCard: React.FC = () => {
    const { t } = useTranslation(['individualization'])
    const { uploadTemplate } = useIndividualizationContext()

    const handleImgChange = (base64: string) => {
        uploadTemplate(base64)
    }

    return (
        <Card
            title={t('upload_templates.drop_title')}
            classes={cx(styles['card-wrapper'])}
        >
            <DropInput onBase64Change={handleImgChange} accept={'image/*'} />
            <Text>{t('upload_templates.drop_text')}</Text>
        </Card>
    )
}

export default NewTemplateCard
